(function () {
  const modal = jQuery('#modal-sessionCheck');
  if (modal.length === 0) {
    return;
  }

  const logoutForm = jQuery('#logout-form');
  const lifetime = (parseInt(modal.data('lifetime')) - 1) * 60 ;
  const alertIn = lifetime - 10 * 60;
  let toAlert, toLogout;

  const logout = function () {
    window.location.href = '/autoLogout';
  };

  const keepAlive = function () {
    jQuery.post('/keepAlive', {ping: 1, _token: modal.data('token')})
      .then(function () {
        handleSessionAlert();
        toggleModal();
      });
  };

  const toggleModal = function () {
    if (logoutForm.length === 0) {
      return;
    }
    modal.modal('toggle');
  };

  const handleActions = function () {
    modal.find('#sessionCheckLogout').on('click', function (e) {
      e.preventDefault();
      logout();
      return false;
    });
    modal.on('click', function () {
      keepAlive();
    });
  };

  const handleSessionAlert = function () {
    clearTimeout(toAlert);
    clearTimeout(toLogout);
    toAlert = setTimeout(toggleModal, alertIn * 1000);
    toLogout = setTimeout(logout, lifetime * 1000);
  }

  handleSessionAlert();
  handleActions()
})();
